import { closeModal, openModal } from './modal.js'

const SITE_DOMAIN = location.hostname
const domainWhitelist = ['foundation.metrocu.org', 'join.metrocu.org', 'secure.myvirtualbranch.com/metrocu', 'app.loanspq.com', 'timetrade.com', 'metrocu.everfi-next.net', 'metrocu.insuranceaisle.com', 'advice.metrocu.org', 'getmyrate.metrocu.org', 'simplenexus.com', 'metrocu.cudlautosmart.com', 'apps.myvirtualstrongbox.com', 'auth.myvirtualstrongbox.com', 'us61e2.dayforcehcm.com', 'billerpayments.com', 'cbsinvestorconnection.com', 'brokercheck.finra.org', 'referlive.com', 'metrocu.coconutcalendar.com'];
const links = document.querySelectorAll('a:not([data-continue-link])')

/**
 * Handler for opening the offsite modal
 * and updating the continue url
 * @param event
 */
const handleExternalLink = (event) => {
    openModal('offsite', event.currentTarget)
    const elOffsiteModal = document.querySelector('[data-modal="offsite"]')
    const elOffsiteModalLink = elOffsiteModal.querySelector('[data-continue-link]')
    elOffsiteModalLink.href = event.currentTarget.href
    elOffsiteModalLink.addEventListener('click', () => closeModal('offsite'))
}

/**
 * Checks is a clicked link is offsite
 * @param event
 */
export const handleLinkClick = (event) => {
    let clickedEl = event.currentTarget

    // Handle cases where links have nested elements
    // that might be the click target
    if (event.target.nodeName !== 'A') {
        clickedEl = event.target.closest('a')
    }

    if (isExternal(clickedEl)) {
        event.preventDefault()
        handleExternalLink(event)
    }
}

const isInWhitelist = (href) => {
    return domainWhitelist.some((domain) => href.toLowerCase().includes(domain))
}

const isExternal = (link) => {
    const linkHref = link.getAttribute('href')
    if (link.hostname === SITE_DOMAIN) return false
    if (linkHref.includes('tel:') || link.getAttribute('href').includes('mailto:')) return false
    if (isInWhitelist(linkHref)) return false

    return true
}

links.forEach((elLink) => {
    elLink.addEventListener('click', handleLinkClick)
})
